const promocaoCondicao = {
    NA_COMPRA_DE_PRODUTO: 1,
    NA_COMPRA_DE_PRODUTO_DA_CATEGORIA: 2,

    desc: (value) => {
        switch(value){
            case 1:
                return 'Na compra de [Nº] produtos';

            case 2:
                return 'Na compra de [Nº] produtos da categoria';

            default:
                return '-'
        }
    }
}

export default promocaoCondicao;